// Module
var code = "<div class=\"block-7__items\"></div> <template id=\"block-7__item-template\"> <div class=\"block-7__items__item\"> <div class=\"image\"></div> <div class=\"block-7__items__item__caption\"> <div class=\"text\"></div> <div class=\"credits\"></div> </div> </div> </template> ";
// Exports
export default code;